import React from "react";
import { BaseAnnouncerPack } from "./BaseAnnouncerPack";
import DefaultAnnouncerPack from "./DefaultAnnouncerPack";
import {
  MessageAnimationContext,
  MessageAnimationHandler,
} from "../../../../client/components/MultiPlayer/messageAnimations";

export abstract class BaseFragAnnouncerPack extends BaseAnnouncerPack {
  private defaultPack?: DefaultAnnouncerPack;

  getAnimationHandler(
    eventType: string,
    context: MessageAnimationContext
  ): MessageAnimationHandler | null {
    if (eventType === "frag") {
      return this.handleFrag;
    }

    const defaultPack = this.ensureDefaultPack();
    return defaultPack.getAnimationHandler(eventType, context);
  }

  private handleFrag = (
    context: MessageAnimationContext
  ): React.ReactElement => {
    if (context.message.type !== "frag") {
      context.onComplete();
      return <></>;
    }

    if (this.isVictim(context)) {
      const playAudio = this.createPlayAudioCallback("frag");
      const enhancedContext: MessageAnimationContext = {
        ...context,
        playAudio: playAudio ?? undefined,
        audioName: this.getAudioName("frag") ?? undefined,
      };
      return this.getVictimHandler(enhancedContext);
    }

    const defaultPack = this.ensureDefaultPack();
    const defaultHandler = defaultPack.getAnimationHandler("frag", context);
    return defaultHandler ? defaultHandler(context) : <></>;
  };

  protected isVictim(context: MessageAnimationContext): boolean {
    if (context.message.type !== "frag") return false;
    for (const [, player] of context.gameState.players.entries()) {
      if (player.numPlayer === context.message.fraggedNumPlayer) {
        return player.connectionId === context.localConnectionId;
      }
    }
    return false;
  }

  protected abstract getVictimHandler(
    context: MessageAnimationContext
  ): React.ReactElement;

  private ensureDefaultPack(): DefaultAnnouncerPack {
    if (!this.defaultPack) {
      this.defaultPack = new DefaultAnnouncerPack();
      if (this.audioManager) {
        this.defaultPack.initialize(this.audioManager);
      }
    } else if (this.audioManager) {
      this.defaultPack.initialize(this.audioManager);
    }
    return this.defaultPack;
  }
}

